'use strict';
(() => {
  const storageKey = 'vorug:swatch-selection:v1';

  function init(root) {
    if (root.dataset.vscReady) return;
    const data = JSON.parse(root.querySelector('[data-vsc-data]').textContent);
    const strings = JSON.parse(root.querySelector('[data-vsc-strings]').textContent);
    const bundles = new Map(data.bundles.map(bundle => [bundle.id, bundle]));
    const poms = new Map();
    const selected = new Set();
    const dialog = root.querySelector('[data-vsc-dialog]');
    const title = root.querySelector('[data-vsc-detail-title]');
    const image = root.querySelector('[data-vsc-detail-image]');
    const members = root.querySelector('[data-vsc-members]');
    const membersHeading = root.querySelector('.vsc-members-heading');
    const detailControls = root.querySelector('[data-vsc-detail-controls]');
    const bar = root.querySelector('[data-vsc-selection-bar]');
    const count = root.querySelector('[data-vsc-selection-count]');
    const clear = root.querySelector('[data-vsc-selection-clear]');
    const request = root.querySelector('[data-vsc-selection-request]');
    const feedback = root.querySelector('[data-vsc-feedback]');
    const detailFeedback = root.querySelector('[data-vsc-detail-feedback]');
    let trigger = null;

    function selectControl(code, kind = 'pom') {
      const label = document.createElement('label');
      label.className = 'vsc-checkbox';
      const input = document.createElement('input');
      input.type = 'checkbox';
      input.dataset[kind === 'pom' ? 'vscSelectCode' : 'vscSelectBundle'] = code;
      const mark = document.createElement('span');
      mark.className = 'vsc-checkbox-mark';
      mark.setAttribute('aria-hidden', 'true');
      mark.innerHTML = '<svg class="vsc-checkbox-check" viewBox="0 0 20 20" focusable="false"><path d="m4 10 4 4 8-8" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><svg class="vsc-checkbox-mixed" viewBox="0 0 20 20" focusable="false"><path d="M4 10h12" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
      label.append(input, mark);
      return label;
    }

    function copyButton(code) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'vsc-tcx-code vsc-copy-pantone';
      button.dataset.vscCopyCode = code;
      button.textContent = poms.get(code).pantoneCode;
      button.setAttribute('aria-label', `${strings.copyPantone}: ${button.textContent}`);
      return button;
    }

    function pantoneLine(pom) {
      const line = document.createElement('p');
      line.className = 'vsc-pantone';
      const label = document.createElement('span');
      label.textContent = data.approxLabel;
      const name = document.createElement('span');
      name.append(document.createTextNode(pom.pantoneName), copyButton(pom.code));
      line.append(label, name);
      return line;
    }

    for (const card of root.querySelectorAll('.vsc-pom')) {
      const code = card.querySelector('.vsc-caption > span').textContent.trim();
      const name = card.querySelector('.vsc-caption h3').textContent.trim();
      const reference = card.querySelector('.vsc-tcx-code');
      const pantoneCode = reference.textContent.trim();
      const pantoneName = reference.parentElement.textContent.replace(pantoneCode, '').trim();
      poms.set(code, {code, name, pantoneName, pantoneCode, image: card.querySelector('img').src});
      card.dataset.vscPom = code;
      card.id = `vsc-${root.dataset.vscSection}-pom-${code}`;
      const photo = card.querySelector('.vsc-image');
      const opener = document.createElement('div');
      opener.className = 'vsc-image vsc-pom-open';
      opener.dataset.vscCardPom = code;
      opener.append(...photo.childNodes);
      photo.replaceWith(opener);
      const codeText = document.createElement('span');
      codeText.className = 'vsc-tcx-code';
      codeText.textContent = pantoneCode;
      reference.replaceWith(codeText);
      card.prepend(selectControl(code));
    }

    for (const card of root.querySelectorAll('.vsc-bundle')) {
      const photo = card.querySelector('[data-vsc-bundle]');
      const id = photo.dataset.vscBundle;
      card.dataset.vscBundleCard = id;
      const selector = document.createElement('div');
      selector.className = 'vsc-image vsc-bundle-select-photo';
      selector.dataset.vscCardBundle = id;
      selector.append(...photo.childNodes);
      photo.replaceWith(selector);
      card.prepend(selectControl(id, 'bundle'));
    }

    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
      if (Array.isArray(saved)) saved.forEach(code => {
        if (typeof code === 'string' && poms.has(code)) selected.add(code);
      });
    } catch (_) {}

    function detail(source = 'snapshot', sourceId = '', sourceTrigger = null) {
      const items = [...poms.values()].filter(pom => selected.has(pom.code)).map(pom => ({
        id: `pom:${pom.code}`, type: 'pom', code: pom.code, name: pom.name,
        pomCodes: [pom.code], image: pom.image, pantoneName: pom.pantoneName, pantoneCode: pom.pantoneCode
      }));
      const bundleSelections = [...bundles.values()].map(bundle => {
        const pomCodes = bundle.members.map(pom => pom.code);
        const selectedPomCodes = pomCodes.filter(code => selected.has(code));
        return {id: bundle.id, name: bundle.name, pomCodes, selectedPomCodes,
          state: selectedPomCodes.length === pomCodes.length ? 'full' : 'partial'};
      }).filter(bundle => bundle.selectedPomCodes.length);
      return {items, pomCodes: items.map(pom => pom.code), bundleSelections,
        sectionId: root.dataset.vscSection, trigger: sourceTrigger, source, sourceId};
    }

    function refresh(source, sourceId = '', sourceTrigger = null, emit = true) {
      root.querySelectorAll('[data-vsc-select-code]').forEach(input => {
        const pom = poms.get(input.dataset.vscSelectCode);
        input.checked = selected.has(pom.code);
        input.setAttribute('aria-label', `${strings.selectPom}: ${pom.name} (${pom.code})`);
      });
      root.querySelectorAll('[data-vsc-pom]').forEach(card => {
        const active = selected.has(card.dataset.vscPom);
        card.dataset.vscSelected = String(active);
      });
      root.querySelectorAll('[data-vsc-select-bundle]').forEach(input => {
        const bundle = bundles.get(input.dataset.vscSelectBundle);
        const size = bundle.members.filter(pom => selected.has(pom.code)).length;
        const full = size === bundle.members.length;
        const state = full ? 'full' : size ? 'partial' : 'empty';
        input.checked = full;
        input.indeterminate = !full && size > 0;
        const status = strings.bundleStatus.replace('__SELECTED__', size).replace('__TOTAL__', bundle.members.length);
        input.setAttribute('aria-label', `${strings.selectBundle}: ${bundle.name}, ${status}`);
        const card = input.closest('[data-vsc-bundle-card]');
        card?.setAttribute('data-vsc-selected', state);
      });
      count.textContent = selected.size === 1 ? strings.selectedOne : strings.selectedCount.replace('__COUNT__', selected.size);
      clear.disabled = !selected.size;
      request.disabled = !selected.size;
      bar.hidden = !selected.size;
      barSpace();
      try { sessionStorage.setItem(storageKey, JSON.stringify([...selected])); } catch (_) {}
      if (emit) root.dispatchEvent(new CustomEvent('vorug:swatch-selection-change', {
        bubbles: true, detail: detail(source, sourceId, sourceTrigger)
      }));
    }

    function showDetail(nextTrigger) {
      trigger = nextTrigger;
      detailFeedback.textContent = '';
      if (typeof dialog.showModal !== 'function') return;
      if (!dialog.open) dialog.showModal();
      dialog.scrollTop = 0;
      document.body.classList.add('vsc-detail-open');
    }

    function openPom(code, nextTrigger) {
      const pom = poms.get(code);
      if (!pom) return;
      title.textContent = `${pom.name} (${pom.code})`;
      image.src = pom.image;
      image.alt = pom.name;
      members.replaceChildren();
      members.hidden = true;
      membersHeading.hidden = true;
      detailControls.replaceChildren(pantoneLine(pom), selectControl(code));
      detailControls.hidden = false;
      refresh('detail', code, nextTrigger, false);
      showDetail(nextTrigger);
    }

    function openBundle(id, nextTrigger) {
      const bundle = bundles.get(id);
      if (!bundle) return;
      title.textContent = bundle.name;
      image.src = bundle.image;
      image.alt = bundle.name;
      members.replaceChildren();
      members.hidden = false;
      membersHeading.hidden = false;
      const control = selectControl(id, 'bundle');
      const help = document.createElement('p');
      help.className = 'vsc-bundle-help';
      help.textContent = strings.bundleHelp;
      detailControls.replaceChildren(control, help);
      detailControls.hidden = false;
      for (const member of bundle.members) {
        const pom = poms.get(member.code);
        const item = document.createElement('li');
        const thumbnail = document.createElement('img');
        thumbnail.src = pom.image;
        thumbnail.alt = pom.name;
        thumbnail.width = 768;
        thumbnail.height = 768;
        thumbnail.loading = 'lazy';
        thumbnail.decoding = 'async';
        const caption = document.createElement('div');
        caption.className = 'vsc-caption';
        const name = document.createElement('h4');
        name.textContent = pom.name;
        const code = document.createElement('span');
        code.textContent = pom.code;
        caption.append(name, code);
        item.className = 'vsc-member-card';
        item.append(selectControl(pom.code), thumbnail, caption, pantoneLine(pom));
        members.append(item);
      }
      refresh('detail', id, nextTrigger, false);
      showDetail(nextTrigger);
    }

    async function copyReference(button) {
      const pom = poms.get(button.dataset.vscCopyCode);
      if (!pom) return;
      const text = `${data.approxLabel}: ${pom.pantoneName} (${pom.pantoneCode})`;
      let localFeedback = button.parentElement.querySelector('.vsc-copy-feedback');
      if (!localFeedback) {
        localFeedback = document.createElement('span');
        localFeedback.className = 'vsc-copy-feedback';
        localFeedback.setAttribute('aria-hidden', 'true');
        button.after(localFeedback);
      }
      try {
        if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(text);
        else {
          const field = document.createElement('textarea');
          field.value = text;
          field.className = 'vsc-clipboard-field';
          dialog.open ? dialog.append(field) : root.append(field);
          field.select();
          const copied = document.execCommand('copy');
          field.remove();
          button.focus({preventScroll: true});
          if (!copied) throw new Error('Clipboard unavailable');
        }
        localFeedback.textContent = strings.copied;
        button.parentElement.querySelector('.vsc-manual-copy')?.remove();
        (dialog.open ? detailFeedback : feedback).textContent = `${strings.copied} ${text}`;
      } catch (_) {
        localFeedback.textContent = strings.copyFailed;
        (dialog.open ? detailFeedback : feedback).textContent = strings.copyFailed;
        let field = button.parentElement.querySelector('.vsc-manual-copy');
        if (!field) {
          field = document.createElement('input');
          field.type = 'text';
          field.readOnly = true;
          field.className = 'vsc-manual-copy';
          field.setAttribute('aria-label', `${data.approxLabel}: ${pom.name} (${pom.code})`);
          localFeedback.after(field);
        }
        field.value = text;
        field.focus({preventScroll: true});
        field.select();
      }
    }

    function toggleSelection(input) {
      if (input.matches('[data-vsc-select-code]')) {
        const code = input.dataset.vscSelectCode;
        if (!poms.has(code)) return;
        selected.has(code) ? selected.delete(code) : selected.add(code);
        refresh('pom', code, input);
      } else if (input.matches('[data-vsc-select-bundle]')) {
        const bundle = bundles.get(input.dataset.vscSelectBundle);
        if (!bundle) return;
        const full = bundle.members.every(pom => selected.has(pom.code));
        bundle.members.forEach(pom => full ? selected.delete(pom.code) : selected.add(pom.code));
        refresh('bundle', bundle.id, input);
      }
    }
    root.addEventListener('change', event => toggleSelection(event.target));
    root.addEventListener('click', event => {
      const card = event.target.closest('[data-vsc-pom], [data-vsc-bundle-card]');
      if (card && !dialog.contains(card)) {
        if (event.target.closest('.vsc-checkbox')) return;
        event.preventDefault();
        const input = card.querySelector('[data-vsc-select-code], [data-vsc-select-bundle]');
        if (input) toggleSelection(input);
        return;
      }
      const target = event.target.closest('button');
      if (!target) return;
      if (target.matches('[data-vsc-selection-clear]')) {
        selected.clear();
        refresh('clear', '', target);
        const heading = root.querySelector('.vsc-pom-grid').closest('section').querySelector('h2');
        heading.tabIndex = -1;
        heading.focus({preventScroll: true});
        heading.scrollIntoView({block: 'start', behavior: 'auto'});
      } else if (target.matches('[data-vsc-selection-request]')) {
        if (!selected.size) return;
        barSpace();
        root.dispatchEvent(new CustomEvent('vorug:swatch-request', {
          bubbles: true, detail: detail('request', '', target)
        }));
      } else if (target.matches('[data-vsc-copy-code]')) copyReference(target);
      else if (target.matches('[data-vsc-open-pom]')) openPom(target.dataset.vscOpenPom, target);
      else if (target.matches('[data-vsc-open-bundle]')) openBundle(target.dataset.vscOpenBundle, target);
    });
    root.querySelector('[data-vsc-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.body.classList.remove('vsc-detail-open');
      trigger?.focus({preventScroll: true});
    });
    root.vorugSwatchSelection = {
      getDetail: () => detail(),
      remove: code => {
        if (typeof code !== 'string' || !poms.has(code) || !selected.delete(code)) return false;
        refresh('remove', code);
        return true;
      }
    };
    root.addEventListener('focusin', event => {
      if (bar.hidden || dialog.open || document.body.classList.contains('hidden') || document.body.classList.contains('vsrf-drawer-open') || bar.contains(event.target)) return;
      const bottom = event.target.getBoundingClientRect().bottom;
      const barTop = bar.getBoundingClientRect().top;
      if (bottom > barTop - 16) window.scrollBy({top: bottom - barTop + 16, behavior: 'auto'});
    });
    root.dataset.vscReady = 'true';
    function barSpace() {
      const offset = window.vorugViewport?.previewInset || 0;
      root.style.setProperty('--vsc-preview-offset', `${offset}px`);
      const space = bar.hidden ? 0 : Math.ceil(bar.getBoundingClientRect().height) + offset + 24;
      root.style.setProperty('--vsc-selection-space', `${space}px`);
    }
    root.vscViewportUpdate = barSpace;
    document.addEventListener('vorug:viewport-change', barSpace);
    if (typeof ResizeObserver === 'function') {
      const observer = new ResizeObserver(barSpace);
      observer.observe(bar);
      root.vscResizeObserver = observer;
    }
    barSpace();
    refresh('restore');
    const requestedPom = new URLSearchParams(location.search).get('pom');
    if (poms.has(requestedPom)) {
      openPom(requestedPom, root.querySelector(`[data-vsc-select-code="${requestedPom}"]`));
    }
  }

  document.querySelectorAll('[data-vorug-color-library]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-vorug-color-library]').forEach(init));
  document.addEventListener('shopify:section:unload', event => {
    for (const root of event.target.querySelectorAll('[data-vorug-color-library]')) {
      const dialog = root.querySelector('[data-vsc-dialog]');
      if (dialog?.open) dialog.close();
      root.vscResizeObserver?.disconnect();
      document.removeEventListener('vorug:viewport-change', root.vscViewportUpdate);
    }
    if (!document.querySelector('[data-vorug-color-library] [data-vsc-dialog][open]')) document.body.classList.remove('vsc-detail-open');
  });
})();
